import { z } from 'zod';

export const transitViewGeneralInfoSchema = z.object({
  customer: z.string().optional().nullable(),
  TransitOperation: z.object({
    security: z.string().optional().nullable(),
    additionalDeclarationType: z.string().optional().nullable(),
    specificCircumstanceIndicator: z.string().optional().nullable(),
    bindingItinerary: z.string().optional().nullable(),
    limitDate: z.string().optional().nullable(),
  }),
  CustomsOfficeOfDeparture: z.object({
    referenceNumber: z.string().optional().nullable(),
  }),
  CustomsOfficeOfDestinationDeclared: z.object({
    referenceNumber: z.string().optional().nullable(),
  }),
  CustomsOfficeOfDestinationActual: z.object({
    referenceNumber: z.string().optional().nullable(),
  }),
  Guarantee: z.array(
    z.object({
      guaranteeType: z.string().optional().nullable(),
      GuaranteeReference: z.array(
        z.object({
          accessCode: z.string().optional().nullable(),
          currency: z.string().optional().nullable(),
          GRN: z.string().optional().nullable(),
          amountToBeCovered: z.string().optional().nullable(),
          setFromCustomer: z.boolean(),
        }),
      ),
    }),
  ),
  Authorisation: z.array(
    z.object({
      type: z.string().optional().nullable(),
      referenceNumber: z.string().optional().nullable(),
    }),
  ),
  CustomsOfficeOfTransitDeclared: z.array(
    z.object({
      referenceNumber: z.string().optional().nullable(),
      arrivalDateAndTimeEstimated: z.string().optional().nullable(),
    }),
  ),
  Consignment: z.object({
    grossMass: z.string().optional().nullable(),
    referenceNumberUCR: z.string().optional().nullable(),
    countryOfDestination: z.string().optional().nullable(),
    countryOfDispatch: z.string().optional().nullable(),
    inlandModeOfTransport: z.string().optional().nullable(),
    modeOfTransportAtTheBorder: z.string().optional().nullable(),
    PlaceOfLoading: z.object({
      UNLocode: z.string().optional().nullable(),
      country: z.string().optional().nullable(),
      location: z.string().optional().nullable(),
    }),
    PlaceOfUnloading: z.object({
      UNLocode: z.string().optional().nullable(),
      country: z.string().optional().nullable(),
      location: z.string().optional().nullable(),
    }),
    LocationOfGoods: z.object({
      UNLocode: z.string().optional().nullable(),
      typeOfLocation: z.string().optional().nullable(),
      qualifierOfIdentification: z.string().optional().nullable(),
      additionalIdentifier: z.string().optional().nullable(),
      authorisationNumber: z.string().optional().nullable(),
      Address: z.object({
        streetAndNumber: z.string().optional().nullable(),
        postcode: z.string().optional().nullable(),
        city: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
      }),
      PostcodeAddress: z.object({
        postcode: z.string().optional().nullable(),
        country: z.string().optional().nullable(),
        houseNumber: z.string().optional().nullable(),
      }),
    }),
    TransportEquipment: z.array(
      z.object({
        containerIdentificationNumber: z.string().optional().nullable(),
        Seal: z.array(
          z.object({
            identifier: z.string().optional().nullable(),
          }),
        ),
      }),
    ),
    DepartureTransportMeans: z.array(
      z.object({
        typeOfIdentification: z.string().optional().nullable(),
        identificationNumber: z.string().optional().nullable(),
        nationality: z.string().optional().nullable(),
      }),
    ),
    CountryOfRoutingOfConsignment: z.array(
      z.object({
        country: z.string().optional().nullable(),
      }),
    ),
    ActiveBorderTransportMeans: z.array(
      z.object({
        typeOfIdentification: z.string().optional().nullable(),
        identificationNumber: z.string().optional().nullable(),
        nationality: z.string().optional().nullable(),
        customsOfficeAtBorderReferenceNumber: z.string().optional().nullable(),
        conveyanceReferenceNumber: z.string().optional().nullable(),
      }),
    ),
    TransportCharges: z.object({
      methodOfPayment: z.string().optional().nullable(),
    }),
    HouseConsignment: z.array(
      z.object({
        ConsignmentItem: z.array(
          z.object({
            Commodity: z.object({
              CommodityCode: z.object({
                initialAmountToPayForDuties: z.string().optional().nullable(),
                initialAmountToPayForVat: z.string().optional().nullable(),
              }),
            }),
          }),
        ),
      }),
    ),
  }),
  refreshCustomerData: z.boolean().optional().nullable(),
});

export type TransitViewGeneralInfoFormValues = z.infer<typeof transitViewGeneralInfoSchema>;
